import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { GemstoneTypeWithShape } from 'src/app/interfaces/gemstone-type-with-shape';
import { StoneTypesWithShapesProviderService } from 'src/app/providers/stone-types-with-shapes/stone-types-with-shapes.provider.service';

@Injectable({
  providedIn: 'root'
})
export class StoneTypesWithShapesService extends ApiService<GemstoneTypeWithShape, StoneTypesWithShapesProviderService> {
  private providerService = inject(StoneTypesWithShapesProviderService);
  protected override get provider(): StoneTypesWithShapesProviderService {
    return this.providerService;
  }
}
